import { render, staticRenderFns } from "./InvoiceInfoExpand.vue?vue&type=template&id=989cc6c4&"
import script from "./InvoiceInfoExpand.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfoExpand.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfoExpand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports